<template>
  <div class="loading">
    <div class="spinner">
      <i class="fa fa-circle-o-notch fa-spin fa-3x fa-fw" aria-hidden="true"></i>
      <p>Carregando...</p>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.loading {
  position: fixed;
  z-index: 9006;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: #00000066;
  text-align: center;
  overflow: auto;
}

.spinner {
  position: relative;
  top: 40%;
  color: white;
  font-size: 20px;
}
</style>
